import React, { Component } from 'react'
import { translate, Translate } from 'react-i18nify'
import { Hidden } from 'react-grid-system'
import Button from '../../Button/Button'
import FormCreationOptions from '../../Forms/FormCreationOptions'

export default class CreationOptions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            save: undefined,
            cancel: undefined,
        }

        this.save = this.save.bind(this)
        this.setLoadingValue = this.setLoadingValue.bind(this)
        this.formRef = React.createRef()
    }

    save() {
        this.setState({ loading: true })
        this.formRef.current.save()
    }

    setLoadingValue(value) {
        this.setState({ loading: value })
    }

    render() {
        return (
            <div className="card--simple">
                <div className="onboarding__content">
                    <h1 className="mixed-case">{translate('onboarding.creation_options.title')}</h1>
                    <FormCreationOptions
                        onCancel={this.props.prevStep}
                        onSave={this.props.nextStep}
                        setLoadingValue={this.setLoadingValue}
                        ref={this.formRef}
                        loading={this.state.loading}
                        className="form--bg form--bg--full-width"
                    />

                    <div className="card--simple__buttons">
                        <div>
                            <Button
                                className={
                                    'button--alt inline-block' +
                                    (this.state.loading ? ' is-loading' : '')
                                }
                                buttonText={translate('buttons.continue')}
                                onClick={() => {
                                    this.save()
                                }}
                            />
                        </div>
                        {!this.state.loading && (
                            <Hidden xs>
                                <button
                                    onClick={() => {
                                        this.props.prevStep()
                                    }}
                                    className="button--link inline-block"
                                >
                                    <i className="mdi mdi-arrow-left" />
                                    <Translate value="onboarding.button_back" />
                                </button>
                            </Hidden>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
